<template>
  <div>
    <!-- 试题智能检测标题 -->
    <!-- <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title> -->
    <div class="mainTopBtn">
      <div class="title-wrapper">
        <span>试题智能检测模板维护</span>
        <el-tooltip
          effect="light"
          placement="right"
          popper-class="custom-tooltip"
        >
          <span class="indicator">
            <span class="blue-circle">!</span>
          </span>
          <p slot="content" v-html="templateDesc"></p>
        </el-tooltip>
      </div>
      <el-button
        round
        type="primary"
        @click="addTemplate"
        >新增</el-button>
    </div>
    <!-- table 表格 -->
    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableOption="tableOption"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>
    <!-- 新增/编辑模板 -->
    <ots-custom-dialog
      :dialog.sync="downDialog"
      :title="isAddDesc"
      width="640px"
    >
      <template v-slot:content>
        <div class="exportDialog">
          <el-form :model="addTemplateForm" ref="addTemplateForm" :rules="addTemplateRules">
            <!-- 模板名称 -->
            <el-form-item label="模板名称" prop="templateName">
              <el-input
                v-model.trim="addTemplateForm.templateName"
                placeholder="请输入"
                auto-complete="new-text"
              ></el-input>
            </el-form-item>

            <!-- 模板选项 -->
            <el-form-item
              label="模板选项"
              style="width: 100%;"
              prop="itemIds"
            >
            <div class="checkUser">
              <el-checkbox-group
                v-model="addTemplateForm.itemIds"
              >
                <el-checkbox
                  v-for="item in templateItems"
                  :label="item.id"
                  :key="item.id"
                  :disabled="item.isMust === 1"
                  @change="changeCheck(item.id)"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="downDialog = false">取消</el-button>
        <el-button
          round
          type="primary"
          @click="addTemplateSet('addTemplateForm')"
          v-if="isdisabled"
          >确定</el-button
        >
        <el-button
          round
          type="primary"
          @click="editTemplateSet('addTemplateForm')"
          v-else
          >确定</el-button
        >
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import {
  getDetecteTemplateByIdApi,
  getListDetecteTemplateApi,
  addDetecteTemplateApi,
  updateDetecteTemplateApi,
  deleteDetecteTemplateApi,
  intelligentDetecte4OtsApi,
  getDetecteItemListApi,
  setDefaultDetecteTemplateApi
 } from "@/http/modules/dataV";

export default {
  name: "intelligentDetecteTemplate",
  data() {
    return {
      /* ***** 添加院校用户 ***** */
      isAddDesc: "",
      isdisabled: true,
      downDialog: false,
      addTemplateForm: {
        templateId: "",
        templateName: "",
        templateRemark: "",
        itemIds: [],
      },
      addTemplateRules: {
        templateName: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
          { max: 50, message: "最多可输入50个字!", trigger: "blur" }
        ]
      },

      templateItems: [],

      /* ***** 角色管理标题 ***** */
      // mainTopBtnList: [
      //   {
      //     title: "新增",
      //     fn: this.addTemplate,
      //   },
      // ],
      /* ***** 表格 ***** */
      templateDesc: "",
      tableData: [],
      tableOption: {},
      tableHeader: [
        {
          title: "序号",
          prop: "orderId",
          fixed: "left",
          width: "100"
        },
        {
          title: "模板名称",
          prop: "name",
          fixed: "left",
          width: "200"
        },
        {
          title: "检测项",
          prop: "itemNames",
          fixed: "left",
          width: "800",
          align: "left"
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "编辑",
              formatter: function(scope) {
                return scope.row.name == "系统默认模板";
              },
              click: this.editTemplate,
            },
            {
              title: "删除",
              click: this.deleteTemplate,
              formatter: function(scope) {
                return scope.row.name == "系统默认模板";
              },
            },
            {
              title: "设为默认",
              formatter: function(scope) {
                return scope.row.isDefault == 1;
              },
              click: this.setDefaultTemplate,
            },
          ],
        },
      ],
      /* ***** 分页 ***** */
      pagination: {
        total: 0,
        size: 10,
      },
      /* ** 分页参数 ** */
      listParams: {
        page: 1,
        size: 10
      },
      have6Flag : false,
    };
  },
  mounted() {
    this.getTemplateDesc();
    this.getResult();
  },
  methods: {
    /********************************
     * @this 获取叹号里面的提示
     ********************************/
    async getTemplateDesc() {
      const res = await getDetecteItemListApi();
      if (res.code == 1) {
        this.templateDesc = res.data.map(item => `${item.name}：${item.remark}`).join('<br>');
      }
    },
    /********************************
     * @this 获取表格数据***table***
     ********************************/
    async getResult() {
        let resultData = await getListDetecteTemplateApi(this.listParams);
        let resultInfo = resultData.data;

        for(let i=0;i<resultInfo.records.length;i++){
        let oCurItem = resultInfo.records[i];
        oCurItem["orderId"] = i+1;
        }

        this.tableData = resultInfo.records.map(record => {
        const itemNames = record.detecteTemplateItemList ?.map(item => item.itemName).join(", ") || "";
            return {
                ...record,
                itemNames,
            };
        });
        this.pagination.total = resultInfo.total;
    },
    /********************************
     * @this 新增院校用户(右上角按钮)
     ********************************/
    addTemplate() {
      this.downDialog = true;
      // 2. 开启表单状态
      this.isdisabled = true;
      this.isAddDesc = "新增模板";
      // 3. 重置表单信息
      this.addTemplateForm.templateName = "";
      // 4. 所属角色列表
      this.templateItems = [];
      // 5. 已选中的所属角色 id 列表
      this.addTemplateForm.itemIds = [];
      // 6. 新增的弹窗里面不包含6
      this.have6Flag = false;
      // 7.获取所属角色列表
      getDetecteItemListApi().then((res) => {
        if (res.code == 1) {
          this.templateItems = res.data;
          res.data.forEach((e) => {
            if(e.isMust == 1){
                this.addTemplateForm.itemIds.push(e.id);
            }
          });
        }
      });
    },

    /****************************
     * @this 新增模板表单提交
     ***************************/
    addTemplateSet(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {...this.addTemplateForm};
          params.itemIds = params.itemIds.join();
          addDetecteTemplateApi(params)
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("添加成功");
                this.getResult();
                this.downDialog = false;
              }
            })
            .catch((error) => {});
        } else {
          console.log("Error Submit");
          return false;
        }
      });
    },

    /********************************
     * @this 编辑模板(按钮)
     ********************************/
    async editTemplate(row) {
      // 1. 修改弹窗 标题
      this.isAddDesc = "编辑模板";
      // 2. 开启弹窗
      this.downDialog = true;
      // 3.禁用 input 标单
      this.isdisabled = false;
      // 4.初始化模板名
      this.addTemplateForm.templateId = row.id;
      this.addTemplateForm.templateName = row.name;
      await getDetecteItemListApi().then((res) => {
        if (res.code == 1) {
          this.templateItems = res.data;
        }
      });
      this.have6Flag = false;
      await getDetecteTemplateByIdApi({ templateId: row.id }).then((res) => {
        this.addTemplateForm.itemIds = [];
        // 5. 设置编辑表单默认数据
        if (res.code == 1) {
          // 6. 获取 选中的所属角色列表
          if (res.data.detecteTemplateItemList.length) {
            res.data.detecteTemplateItemList.forEach((e) => {
                this.addTemplateForm.itemIds.push(e.itemId);
                if(e.itemId == 6){
                  this.have6Flag = true; //判断当前打开弹框的时候，是否包含6
                }
            });
          }
        }
      });
      this.$nextTick(() => {
        if(this.have6Flag){
          this.changeCheck('5');
        }
      });
    },

    /********************************
     * @this 编辑院校用户表单提交
     ********************************/
    editTemplateSet(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 1.配置修改 院校用户信息 参数
          let param = {
            templateId : this.addTemplateForm.templateId,
            templateName : this.addTemplateForm.templateName,
            templateRemark : "",
            itemIds : this.addTemplateForm.itemIds.join(',')
          };
          // 2. 修改模板信息
          updateDetecteTemplateApi(param).then((res) => {
            if (res.code == 1) {
              this.downDialog = false;
              this.getResult();
              this.$message.success("操作成功！");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /********************************
     * @this 修改默认模板
     ********************************/
    async setDefaultTemplate(row) {
      await setDefaultDetecteTemplateApi({ templateId: row.id }).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功！");
          this.getResult();
        }
      });
    },

    /********************************
     * @this 删除列表数据
     ********************************/
    deleteTemplate(row) {
      // 1. 删除用户二次确认
      this.$confirm("是否确认删除该模板？", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteDetecteTemplateApi({ templateId: row.id }).then((res) => {
            if (res.code == 1) {
              this.$message.success("删除成功！");
              this.getResult();
            }
          });
        })
        .catch(() => {});
    },

    /****************************
     * @this 分页相关
     ***************************/
    changeSize(num) {
      this.pagination.size = num;
      this.listParams.size = num;
      this.getResult();
    },
    changePage(p) {
      this.listParams.page = p;
      this.getResult();
    },
    changeCheck(itemId) {
      if(itemId == '5'){
        const have5 = this.addTemplateForm.itemIds.includes('5');
        const have6 = this.addTemplateForm.itemIds.includes('6');
        if(have5){
          if(have6){
            this.templateItems.forEach((e) => {
              if(e.id == '6'){
                e.isMust = 1;
              }
            })
          }else{
            this.addTemplateForm.itemIds.push('6');
            this.templateItems.forEach((e) => {
              if(e.id == '6'){
                e.isMust = 1;
              }
            })
          }
        }else{
          this.templateItems.forEach((e) => {
            if(e.id == '6'){
              e.isMust = 0;
            }
          })
          if(this.have6Flag){
            if(!have6){
              this.addTemplateForm.itemIds.push('6');
            }
          }else{
            this.addTemplateForm.itemIds = this.addTemplateForm.itemIds.filter(e => e !== '6')
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.exportDialog {
  .el-form {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .el-form-item {
      width: 260px;
    }
    /deep/ .el-input__inner {
      width: 260px;
    }
    .checkUser {
      width: 100%;
      background: #f8f9fc;
      border-radius: 4px;
      padding: 19px 0 0 16px;
      margin-bottom: 22px;
      /deep/ .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        .el-checkbox {
          margin-right: 0;
          margin-bottom: 12px;
          width: 50%;
        }
      }
    }
  }
}
.repass {
  .name {
    width: 50%;
    display: inline-block;
    padding-left: 4px;
    box-sizing: border-box;
    margin-bottom: 32px;
    .name-username,
    .name-realname {
      color: #737780;
      font-size: 14px;
      font-weight: 400;
      display: inline-block;
      margin-right: 16px;
    }
    .name-username + span,
    .name-realname + span {
      color: #45494d;
    }
  }
  .el-form {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .el-form-item {
      width: 408px;
      /deep/ .el-form-item__label {
        color: #737780;
      }
    }
    /deep/ .el-input__inner {
      width: 408px;
    }
    .checkUser {
      width: 100%;
      background: #f8f9fc;
      border-radius: 4px;
      padding: 19px 0 0 16px;
      margin-bottom: 22px;
      /deep/ .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        .el-checkbox {
          margin-right: 0;
          margin-bottom: 12px;
          width: 50%;
        }
      }
    }
  }
}

.mainTopBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-wrapper span{
  font-size: 24px; font-weight: 500;
}

.blue-circle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #1890ff;
  color: white;
  font-size: 16px !important;
  font-weight: bold;
  cursor: pointer;
}

.custom-tooltip p {
  line-height: 25px;
  margin: 0;
}
</style>